import { useEffect } from "react";
import { useAppDispatch } from "../redux/store";
import { updatePlayerDetails } from "../redux/slices/menu";
import { FontOptions } from "../types";
import RoomAPI from "../RoomAPI";
import { updateConfig, updateCount } from "../redux/slices/meta";

export const useInitializeApp = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    // Load player details from local storage
    const savedName = localStorage.getItem("playerName");
    const savedSecret = localStorage.getItem("playerSecret");
    const savedSprite = localStorage.getItem("playerSprite");
    const savedMature = localStorage.getItem("playerMature");
    const savedAccessibility = localStorage.getItem("playerAccessibility");

    if (savedName && savedSprite) {
      const accessibility2 = savedAccessibility
        ? savedAccessibility === "true"
          ? FontOptions.COMIC_SANS
          : parseInt(savedAccessibility)
        : FontOptions.DEFAULT;

      dispatch(
        updatePlayerDetails({
          name: savedName,
          secret: savedSecret ?? "",
          meta: {
            sprite_id: parseInt(savedSprite),
            mature: savedMature === "true",
            accessibility: false, // deprecated
            accessibility2,
          },
        })
      );
    }
    // Note: Theme is now managed by uiPreferences slice and loaded on app initialization
  }, [dispatch]);

  useEffect(() => {
    console.log("Initializing app...");
    // Fetch initial config
    RoomAPI.GetConfig().then((c) => {
      dispatch(updateConfig(c));
    });

    // --- Improved Count Logic ---
    // 1. Immediately fetch the current count for a fast UI update.
    RoomAPI.GetCount()
      .then((count) => dispatch(updateCount(count)))
      .catch(console.error);

    // 2. Then, increment the count for this new session. We don't need to wait for it.
    RoomAPI.IncrCount().catch(console.error);

    // 3. Set up the polling interval to keep the count fresh.
    const interval = setInterval(() => {
      RoomAPI.GetCount().then((count) => dispatch(updateCount(count)));
    }, 30000);

    return () => {
      clearInterval(interval);
    };
  }, [dispatch]);
};
